<template>
    <span class="flex text-700 font-medium mb-4 xl:mb-6 
        text-2xl xl:text-3xl lg:text-5xl md:text-4xl">
        {{ content[lang_].title }}
    </span>

    <MobMenu v-if="!loading && tasks" :items=[]>
        <template v-slot:body>
            <div v-for="(task, index) of tasks">
                <div class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:50px" @click="task.popup=true">
                    <div class="flex mr-3 align-items-center">
                        <Avatar v-if="task.reward && task.reward.amount" :label="task.reward.amount+'$'" shape="circle" class="mr-2 text-sm text-green-500 font-medium bg-green-50" />
                    </div>
                    <div class="flex flex-1 justify-content-left align-items-center">
                        <span class="text-600">{{ task.title[lang_] }}</span>
                    </div>
                    <div class="flex justify-content-right align-items-center">
                        <i class="text-blue-500 ml-2" :class="(!task.done)? 'pi pi-angle-right' : 'pi pi-check'" />
                    </div>
                </div>

                <Dialog class="w-full surface-0" modal 
                    v-model:visible="task.popup" 
                    :position="screenSize=='xs' ? 'bottom' : 'center'"
                    :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
                    :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: 'auto' } : { height: 'auto' }"
                    :class="(screenSize=='xs') ? 'border-noround-bottom' : 'max-w-30rem'">
            
                    <template #header>
                        <div class="w-2">&nbsp</div>
                        <div class="w-full align-content-center justify-content-center flex-wrap">
                            <Avatar v-if="task.reward && task.reward.amount" :label="task.reward.amount+'$'" shape="circle" class="flex m-auto text-sm text-green-500 font-medium bg-green-50" size="large"/>
                        </div>
                    </template>
                    <div class="w-full flex flex-column">
                        <span v-if="task.title" class="text-lg font-medium text-900 text-center mb-2">
                            {{ task.title[lang_] }}
                        </span>
                        <span v-if="task.description" class="text-600 text-center my-2">
                            {{ task.description[lang_] }}
                        </span>
                    </div>
                    <template #footer>
                        <div class="w-full flex flex-row mb-4">
                            <span v-if="!task.done" class="w-full flex gap-2">
                                <Button :label="content[lang_].btn_check" @click="taskCheck(task.code)" :loading="loadingTask"
                                    class="flex border-round-lg w-full" severity="secondary" />
                                <Button v-if="task.button" :label="task.button[lang_]" @click="doTask(task.code);task.popup=false" :disabled="loadingTask"
                                    class="flex border-round-lg w-full" />
                            </span>
                            <span v-else class="w-full flex gap-2">
                                <Button :label="content[lang_].btn_done" icon="pi pi-check" class="flex border-round-lg w-full" severity="secondary"/>
                            </span>
                        </div>
                    </template>
                </Dialog>
            </div>
        </template>
    </MobMenu>
    <Skeleton height="2rem" v-else />
</template>

<script>
import Connect from '@/assets/js/Connect'
import MobMenu from '@/components/sides/menu/MobMenu.vue' 

export default {
    data() {
        return {
            showFirstTransferPopUp: false,
            tasks: [],
            loading: false,
            loadingTask: false,

            content: {
                ru: {
                    title: 'Задания',
                    btn_done: 'Выполнено',
                    btn_check: 'Проверить',
                    msg_error: 'Ошибка',
                    msg_error_desc: 'Условие не выполнено',
                    msg_success: 'Успешно',
                    msg_success_desc: 'Задание выполнено',
                },
                en: {
                    title: 'Tasks',
                    btn_done: 'Done',
                    btn_check: 'Check',
                    msg_error: 'Error',
                    msg_error_desc: 'Condition not met',
                    msg_success: 'Success',
                    msg_success_desc: 'Task completed',
                }
            }
        }
    },
    components: {
        MobMenu,
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        screenSize() { return this.$store.getters.StateScreenSize },
    },
    methods: {
        async loadTasks(){
            this.loading = true
            const res = await this.connect.GetTaskList().then(res=>res)
            if(res.result && res.data) {
                for(let i=0; i<res.data.length; i++){
                    const data = {
                        code:           res.data[i].code,
                        title:          res.data[i].title,
                        description:    res.data[i].description,
                        reward:         res.data[i].reward,
                        button:         res.data[i].button,
                        done:           res.data[i].done,
                        popup:          false
                    }
                    this.tasks.push(data)
                }
            }
            this.loading = false
        },
        doTask(code){
            if(!code) return
            switch(code){
                case 'first_transfer':
                    this.$router.push({path: '/personal/transfer/create/'})
                    break
                case 'invite_first_friend':
                    this.$emit('show_invite', true)
                    break
                case 'link_telegram': 
                    this.$router.push({path: '/personal/profile/'})
                    break
                default:
                    break
            }
        },
        async taskCheck(code){
            if(!code) return
            this.loadingTask = true
            const res = await this.connect.CheckTaskByCode(code).then(res=>res)
            if(res.result) {
                for(let i=0; i<this.tasks.length; i++){
                    if(this.tasks[i].code==code){
                        this.tasks[i].done = true
                        break
                    }
                }
                this.$toast.add({severity: 'success', summary: this.content[this.lang_].msg_success, detail: this.content[this.lang_].msg_success_desc, life: 3000})
            } else {
                this.$toast.add({severity: 'error', summary: this.content[this.lang_].msg_error, detail: this.content[this.lang_].msg_error_desc, life: 3000})
            }
            this.loadingTask = false
        }
    },
    beforeCreate(){
        this.connect = new Connect()
    },
    mounted() {
        this.loadTasks()
    }
}
</script>